import { useEffect, useState } from 'react';
import { useStateMachine } from 'little-state-machine';
import { useQueryParams } from '@hooks/useQueryParameters';
import { ProductID } from '@lib/ProductID';
import useSelector from '@redux/typedHooks';
import { updateAction } from './lib/updateAction';

export const MEMBERSHIP_TRACKING_CATEGORY = 'Medlemskap';
export const ENROLLMENT_TRACKING_ACTION = 'Innmelding';

export const useProduct = () => {
  const parameters = useQueryParams();
  const initialProduct = useSelector((state) => {
    if (typeof parameters !== 'undefined') {
      if (typeof parameters.product !== 'undefined') {
        return parameters && state.becomeAMember.data.products[parameters.product];
      }
      return state.becomeAMember.data.products[ProductID.MembershipWithRoadsideAssistance];
    }
    return undefined;
  });

  const [productId, setProductId] = useState(initialProduct?.productNumber);

  useEffect(() => {
    if (initialProduct) setProductId(initialProduct.productNumber);
  }, [initialProduct]);

  const product = useSelector((state) => productId && state.becomeAMember.data.products[productId]);

  return { initialProduct, product, productId, setProductId };
};

export const documentTitle = (step: number | undefined) => {
  if (step === 2) return 'Bli Medlem - Personalia';
  if (step === 3) return 'Bli Medlem - Tilleggsvalg';
  if (step === 4) return 'Bli Medlem - Betaling';
  return 'Bli Medlem';
};

export const useInitializeMembershipProduct = () => {
  const parameters = useQueryParams();
  const {
    actions,
    state: { membershipForm },
  } = useStateMachine({ updateAction });

  const products = useSelector((state) => state.becomeAMember.data.products || {});
  const isUpdating = useSelector((state) => state.becomeAMember.isUpdating);

  const queryProductId = parameters?.product;
  const queryProduct = queryProductId ? products[queryProductId] : undefined;
  const defaultProduct = products[ProductID.MembershipWithRoadsideAssistance];
  const product = queryProduct || (!membershipForm?.product ? defaultProduct : undefined);
  const shouldInitialize =
    !!product && (!membershipForm?.product || membershipForm.product.productId !== product.productNumber);

  useEffect(() => {
    if (!shouldInitialize || !product) return;

    const amount =
      membershipForm?.product?.productId === product.productNumber ? membershipForm.product.amount || 1 : 1;

    actions.updateAction({
      formName: 'membershipForm',
      data: {
        ...membershipForm,
        product: {
          productId: product.productNumber as ProductID,
          amount,
          isHouseholdProduct: product.isHouseholdProduct,
        },
      },
    });
  }, [actions, membershipForm, product, shouldInitialize]);

  return !shouldInitialize && (!!membershipForm?.product || !isUpdating);
};
